 :sm="6" :xs="6"<template>
    <div class="device-type-manange relative">
        <div class="buttons" :style="{position: button_position}">
<!--            <el-button @click="resetForm">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">姓名：</span>
                <el-input v-model="user_name" placeholder="姓名模糊搜索"/>
            </el-col>
<!--            <el-col :md="6" :lg="6" :xl="4" :sm="6" :xs="6">-->
<!--                <span class="fs-14 pd-r-10">类型：</span>-->
<!--                <el-select v-model="role_type" placeholder="请选择类型">-->
<!--                    <el-option-->
<!--                            v-for="item in allType"-->
<!--                            :key="item.id"-->
<!--                            :label="item.name"-->
<!--                            :value="item.id"-->
<!--                    ></el-option>-->
<!--                </el-select>-->
<!--            </el-col>-->
            <el-col :md="9" :lg="5" :xl="5" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">到期时间：</span>
                <el-date-picker
                    v-model="search_expired_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateChange"
                ></el-date-picker>
            </el-col>
            <el-col :md="9" :lg="5" :xl="5" :sm="12" :xs="24">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <div class="docker_buttons">
            <el-button type="primary" :id="'doctorDownload'" @click="exportExcel">导出数据</el-button>
        </div>


        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column width="50px" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="user_name" label="姓名" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column prop="expired_date" label="缴费到期时间" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column  prop="days_remaining" label="缴费到期剩余天数（日）" align="center"
                             label-class-name="label">
                <template scope="scope">
                    <span v-if="scope.row.days_remaining<0" style="color: red">{{scope.row.days_remaining}}</span>
		            <span v-else >{{scope.row.days_remaining}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'doctorEdit'" @click="goEdit(scope.row)"
                           type="text" size="mini">查看
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {isMobile} from "@/api/order";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                user_name: '',
                role_type: '1',
                start_date: '',
                end_date: '',
                search_expired_date: '',
                allType: [
                    {
                        id: 1,
                        name: '特属服务对象'
                    },
                    {
                        id: 3,
                        name: '特属专家'
                    }
                ],
                button_position: 'absolute',
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
            }
        },
        mounted() {
            // 获取特属服务对象列表
            this.getList();
            localStorage.setItem('prev_page', 'userreservation_list')
        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_StatementsServices',
                    method: 'renewalList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_name: this.user_name,
                        role_type: this.role_type,
                        start_expired_date: this.start_date,
                        end_expired_date: this.end_date,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                // this.role_type = "";
                this.user_name = "";
                this.search_expired_date = "";
                this.start_date = "";
                this.end_date = "";
                this.page = 1;
                this.getList();
            },
            dateChange(e){
                if (!e) {
                    this.search_expired_date = null
                    this.start_date = ''
                    this.end_date = ''
                }
            },
            // 搜索
            search() {
                this.page = 1;
                if (this.search_expired_date) {
                    this.start_date = this.search_expired_date[0];
                    this.end_date = this.search_expired_date[1];
                }
                this.getList();
            },

            goEdit(data) {
                // 特属服务对象
                this.$router.push({
                    name: "userDetail", query: {
                        user_id: data.user_id,
                    }
                });
            },

            // 导出数据
            exportExcel() {
                let params = {
                    servername: 'Ruyi_StatementsServices',
                    method: 'renewalList',
                    pageinfo: {
                        page: this.page,
                        perpage: 0,
                    },
                    params: {
                        user_name: this.user_name,
                        role_type: this.role_type,
                    }
                };
                let colums_list = [
                    {title: "类型", key: "role_type"},
                    {title: "姓名", key: "user_name"},
                    {title: "协议到期时间", key: "expired_date"},
                    {title: "协议剩余天数（日）", key: "days_remaining"},
                ];
                let export_data = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    let res_data = res.data;
                    if (parseInt(res_data.code) != 0) {
                        this.$message.error(res_data.msg);
                        return false;
                    }

                    for (let i = 0; i < res_data.data.list.length; i++) {
                        let role_type;
                        switch (res_data.data.list[i].role_type) {
                            case '1':
                                role_type = '特属服务对象';
                                break;
                            case '3':
                                role_type = '特属专家';
                                break;
                        }


                        let item = {
                            role_type: role_type,
                            user_name: res_data.data.list[i].user_name,
                            expired_date: res_data.data.list[i].expired_date,
                            days_remaining: res_data.data.list[i].days_remaining,
                        };
                        export_data.push(item);
                    }
                    export2Excel(colums_list, export_data, "导出续约报表");
                });
            }


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
</style>
